import { observable } from 'mobx'
import * as H from 'history'

class RouterStore {
    @observable
    history!: H.History<{}>
}

export const routerStore = new RouterStore()
